import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserDefaultInfoComponent } from './components/actions/users/user-default-info/user-default-info.component';
import { UserSettingsDetailsComponent } from './components/actions/users/user-settings-details/user-settings-details.component';
import { LoginComponent } from './components/login/login.component';
import { permissionAreaKeyNameOf } from './helpers/permission.helpers';
import { AuthPermissionsGuard } from './routerGuards/auth-permissions.guard';
import { ModalGuard } from './routerGuards/modal.guard';
import { RootPageRouteGuard } from './routerGuards/root-page-route.guard';
import { PlugComponent } from './components/plug/plug.component';

const appRoutes: Routes = [
  { path: '', pathMatch: 'full', children: [], canActivate: [RootPageRouteGuard] },
  {
    path: 'admin',
    loadChildren: () => import('./actions/admin/admin.module').then(m => m.AdminModule),
    data: { areaPermissionKey: permissionAreaKeyNameOf("admin") },
    canLoad: [AuthPermissionsGuard],
    canActivate: [AuthPermissionsGuard],
    canActivateChild: [AuthPermissionsGuard]
  },
  {
    path: 'billing',
    loadChildren: () => import('./actions/billing/billing.module').then(m => m.BillingModule),
    data: { areaPermissionKey: permissionAreaKeyNameOf("billing") },
    canLoad: [AuthPermissionsGuard],
    canActivate: [AuthPermissionsGuard],
    canActivateChild: [AuthPermissionsGuard]
  },
  {
    path: 'claims',
    loadChildren: () => import('./actions/claims/claims.module').then(m => m.ClaimsModule),
    data: { areaPermissionKey: permissionAreaKeyNameOf("claims") },
    canLoad: [AuthPermissionsGuard],
    canActivate: [AuthPermissionsGuard],
    canActivateChild: [AuthPermissionsGuard]
  },
  {
    path: 'inventory',
    loadChildren: () => import('./actions/inventory/inventory.module').then(m => m.InventoryModule),
    data: { areaPermissionKey: permissionAreaKeyNameOf("inventory") },
    canLoad: [AuthPermissionsGuard],
    canActivate: [AuthPermissionsGuard],
    canActivateChild: [AuthPermissionsGuard]
  },
  {
    path: 'marketing',
    loadChildren: () => import('./actions/marketing/marketing.module').then(m => m.MarketingModule),
    data: { areaPermissionKey: permissionAreaKeyNameOf("marketing") },
    canLoad: [AuthPermissionsGuard],
    canActivate: [AuthPermissionsGuard],
    canActivateChild: [AuthPermissionsGuard]
  },
  {
    path: 'medical-report',
    loadChildren: () => import('./actions/medical-report/medical-report.module').then(m => m.MedicalReportModule),
    data: { areaPermissionKey: permissionAreaKeyNameOf("patients") },
    canLoad: [AuthPermissionsGuard],
    canActivate: [AuthPermissionsGuard],
    canActivateChild: [AuthPermissionsGuard]
  },
  {
    path: 'outreach',
    loadChildren: () => import('./actions/outreach/outreach.module').then(m => m.OutreachModule),
    data: { areaPermissionKey: permissionAreaKeyNameOf("outreach") },
    canLoad: [AuthPermissionsGuard],
    canActivate: [AuthPermissionsGuard],
    canActivateChild: [AuthPermissionsGuard]
  },
  {
    path: 'patients',
    loadChildren: () => import('./actions/patient/patient.module').then(m => m.PatientModule),
    data: { areaPermissionKey: permissionAreaKeyNameOf("patients") },
    canLoad: [AuthPermissionsGuard],
    canActivate: [AuthPermissionsGuard],
    canActivateChild: [AuthPermissionsGuard]
  },
  {
    path: 'products',
    loadChildren: () => import('./actions/product/product.module').then(m => m.ProductModule),
    data: { areaPermissionKey: permissionAreaKeyNameOf("product") },
    canLoad: [AuthPermissionsGuard],
    canActivate: [AuthPermissionsGuard],
    canActivateChild: [AuthPermissionsGuard]
  },
  {
    path: 'reports',
    loadChildren: () => import('./actions/report/report.module').then(m => m.ReportModule),
    data: { areaPermissionKey: permissionAreaKeyNameOf("report") },
    canLoad: [AuthPermissionsGuard],
    canActivate: [AuthPermissionsGuard],
    canActivateChild: [AuthPermissionsGuard]
  },
  {
    path: 'sales-orders',
    loadChildren: () => import('./actions/sales-order/sales-order.module').then(m => m.SalesOrderModule),
    data: { areaPermissionKey: permissionAreaKeyNameOf("sales") },
    canLoad: [AuthPermissionsGuard],
    canActivate: [AuthPermissionsGuard],
    canActivateChild: [AuthPermissionsGuard]
  },
  {
    path: 'scheduling',
    loadChildren: () => import('./actions/scheduling/scheduling.module').then(m => m.SchedulingModule),
    data: { areaPermissionKey: permissionAreaKeyNameOf("scheduling") },
    canLoad: [AuthPermissionsGuard],
    canActivate: [AuthPermissionsGuard],
    canActivateChild: [AuthPermissionsGuard]
  },
  // Dashboard
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/dashboard.module/dashboard.module').then(m => m.DashboardModule),
    data: { ignorePermissionsCheck: true },
    canLoad: [AuthPermissionsGuard],
    canActivate: [AuthPermissionsGuard],
    canActivateChild: [AuthPermissionsGuard]
  },
  {
    path: 'work-queues',
    loadChildren: () => import('./actions/work-queues/work-queues.module').then(m => m.WorkQueuesModule),
    data: { ignorePermissionsCheck: true },
    canLoad: [AuthPermissionsGuard],
    canActivate: [AuthPermissionsGuard],
    canActivateChild: [AuthPermissionsGuard]
  },
  // Login
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'user-settings',
    component: UserSettingsDetailsComponent,
    data: { ignorePermissionsCheck: true },
    canActivate: [AuthPermissionsGuard]
  },
  {
    path: 'user-default-info',
    component: UserDefaultInfoComponent,
    data: { ignorePermissionsCheck: true, ignoreDefaultClinicCheck: true },
    canActivate: [AuthPermissionsGuard]
  },
  {
    path: 'plug',
    component: PlugComponent,
    data: { ignorePermissionsCheck: true, ignoreDefaultClinicCheck: true }
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [ModalGuard]
})
export class AppRoutingModule { }
